// Fetches the Builder.io `activity` DATA model and normalizes each entry to a
// flat Activity object. The `activity` model is NOT environment-scoped (its
// entries carry no `environment` field), so — like the `session-role` model in
// getRoleCopy — we do not filter by dataEnv. Paginated in pages of 100.
// Falls back to [] so the block renders.
export const getActivities = async () => {
    const apiKey = getEnv('builderApi');
    if (!apiKey) return [];
    const all = [];
    try {
        let keepGoing = true;
        while (keepGoing) {
            const res = await $fetch('https://cdn.builder.io/api/v3/content/activity', {
                params: {
                    apiKey,
                    limit: 100,
                    offset: all.length,
                    fields: 'id,data',
                    cacheSeconds: 300,
                },
            });
            const results = res?.results || [];
            all.push(...results);
            if (results.length < 100) keepGoing = false;
        }
    } catch (e) {
        console.error('[activities] fetch failed', e);
        return [];
    }
    return all.map((entry) => {
        const d = entry?.data || {};
        // Builder field is `activityType` (fall back to `type` for safety).
        // "Boundless Thriving" was renamed to "Boundless Thinking" (UNB-636);
        // the activity model isn't environment-scoped, so Builder entries can't
        // be migrated for staging alone — normalize the legacy value here.
        const rawType = d.activityType || d.type || '';
        return {
            id: entry.id,
            name: d.name || '',
            // Trimmed: location is optional in Builder (UNB-641), and a field left
            // with only a space would otherwise be truthy and render an empty eyebrow.
            location: (d.location || '').trim(),
            type: rawType === 'Boundless Thriving' ? 'Boundless Thinking' : rawType,
            image: d.image || null,
            description: d.description || '',
            buttonLabel: d.buttonLabel || '',
            buttonUrl: d.buttonUrl || '',
        };
    });
};
